// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Sanity checks for local development (safe to log masked values)
try {
  console.debug('[supabase/client] SUPABASE_URL present:', !!SUPABASE_URL);
  console.debug('[supabase/client] SUPABASE_PUBLISHABLE_KEY present:', !!SUPABASE_PUBLISHABLE_KEY);
} catch (err) {
  // no-op in environments where console is unavailable
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});